import moment from 'moment';

export function getStringFormattedDate(date: Date) {
  return moment(date).format('MMM YYYY');
}

export function getIsraeliFormattedDate(date: Date) {
  return moment(date).format('DD/MM/YYYY');
}

/**
 * Get the year from a given date
 * @param dateStr Given date to get the quarter from
 * @returns Text with the quarter and year
 */
export const getQuarter = dateStr => {
  const date = new Date(dateStr);
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  let quarter;

  if (month > 0 && month < 4) {
    quarter = 'Q1';
  } else if (month >= 4 && month < 7) {
    quarter = 'Q2';
  } else if (month >= 7 && month < 10) {
    quarter = 'Q3';
  } else if (month >= 10 && month <= 12) {
    quarter = 'Q4';
  }

  return `${quarter}-${year}`;
};

/***
 * @description returns the full year from a string date
 */
export const getFullYear = dateStr => {
  const date = new Date(dateStr);
  const year = date.getFullYear();

  return `${year}`;
};

export function convertIsraeliFormatDateToJsDate(israeliDate: string): Date {
  const israeliDateArr: string[] = israeliDate.split('/');
  const newDate = `${israeliDateArr[1]}/${israeliDateArr[0]}/${israeliDateArr[2]}`;
  return new Date(newDate);
}

export function convertDateToMonthFormat(date: Date, isNeedTranslate?: boolean) {
  const dateStr = moment(date).format('DD MMM YYYY');
  return dateStr;
  // return !isNeedTranslate ? dateStr : getHebDate(dateStr);
}

export const monthToHebDict = month => {
  const dict = {
    Jan: 'ינו׳',
    Feb: 'פבר׳',
    Mar: 'מרץ',
    Apr: 'אפר׳',
    May: 'מאי',
    Jun: 'יוני',
    June: 'יוני',
    Jul: 'יולי',
    July: 'יולי',
    Aug: 'אוג׳',
    Sep: 'ספט׳',
    Sept: 'ספט׳',
    Oct: 'אוק׳',
    Nov: 'נוב׳',
    Dec: 'דצמ׳',
  };
  return dict[month];
};

export function checkIfDateMonthFormat(date: string) {
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'June',
    'Jul',
    'July',
    'Aug',
    'Sep',
    'Sept',
    'Oct',
    'Nov',
    'Dec',
  ];

  return months.find(month => date.includes(month));
}

export function convertDateToStringFormat(date: Date) {
  return moment(date).format('YYYY-MM-DD');
}
